// extracted by mini-css-extract-plugin
export default {"productCarousel":"m1-z"};